import { Injectable } from '@angular/core';

/**
 * Thin wrapper around `globalThis.location.assign` so guards/services that need
 * a real (non-Angular-Router) full-page navigation can be unit-tested via DI
 * instead of spying on `globalThis.location` directly.
 *
 * Real Chrome (unlike jsdom) exposes `globalThis.location` as a non-configurable
 * accessor for security reasons, so `spyOn(globalThis.location, 'assign')` throws
 * ("assign is not declared writable or has no setter") in this repo's Karma
 * + real-browser test setup. Same reasoning as the `protected redirectTo()`
 * seam used in the storage-connect components — isolate the assignment
 * behind something spy-able instead of the real browser API.
 */
@Injectable({ providedIn: 'root' })
export class ExternalRedirectService {
    assign(url: string): void {
        globalThis.location.assign(url);
    }
}
